window.updateCartAttributes = (event, checkoutParams) => {
	event.preventDefault();
	const checkoutLink = checkoutParams ? `/checkout?${checkoutParams}` : '/checkout';
	if (!window['ablyft'] || window.abTesting.checkoutExperiments.length === 0 || !ablyft.get) {
		window.location.href = checkoutLink;
	}
	window['ablyft'] = window['ablyft'] || [];
	window['ablyft'].push({
		eventType: 'activatePage',
		pageApiName: 'checkout-page-restaxil',
	});
	const experimentsTable = ablyft.get('activeExperimentIds');
	const attributes = {};
	window.abTesting.checkoutExperiments.forEach((experiment) => {
		const currentVariationID = experimentsTable[experiment.ablyftExperimentID];
		if (currentVariationID) {
			const variationObject = experiment.variations.find((variation) => variation.variationID === currentVariationID);
			attributes[experiment.cartAttributeKey] = variationObject ? variationObject.cartAttributeValue : '';
		}
	});
	if (Object.keys(attributes).length > 0) {
		fetch('/cart/update.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			keepalive: true,
			body: JSON.stringify({
				attributes,
			}),
		}).finally(() => {
			window.location.href = checkoutLink;
		});
	} else {
		window.location.href = checkoutLink;
	}
};
